const SUCCESS = 'success'
const ERROR = 'error'
const INFO = 'info'

export {
  SUCCESS,
  ERROR,
  INFO
}